import { NgModule } from '@angular/core';
import { AppStandardModule } from './modules/app.standard.module';
import { AppIframeModule } from './modules/app.iframe.module';

// Helper function to determine if running in iframe
export function determineIfIframe(): boolean {
  try {
    // Method 1: URL parameter check
    const urlParams = new URLSearchParams(window.location.search);
    const iframeParam = urlParams.get('iframe')?.toLowerCase() === 'true';

    // Method 2: Check if window.self !== window.top
    const isSelfNotTop = window.self !== window.top;

    // Method 3: Try accessing parent location (will throw error if cross-origin iframe)
    let crossOriginCheck = false;
    try {
      crossOriginCheck = window.parent.location.href !== window.location.href;
    } catch (e) {
      // If we get an error, we're likely in a cross-origin iframe
      crossOriginCheck = true;
    }

    return iframeParam || isSelfNotTop || crossOriginCheck;
  } catch (e) {
    // Fallback to just URL parameter in case of unexpected errors
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('iframe')?.toLowerCase() === 'true';
  }
}

// Export the appropriate module based on the iframe parameter
export const AppModule = determineIfIframe()
  ? AppIframeModule
  : AppStandardModule;
